import { ITheme } from '@mui/material/styles'

const styles = (theme: ITheme) => ({
  paper: {
    padding: 0,
    width: '100%',
    boxShadow: 'none',
    position: 'relative',
  },
  title: {
    textAlign: 'center',
    fontSize: '1.375rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: theme.texts.main,
    padding: '20px 16px 12px',
    textTransform: 'capitalize',
  },
  root: {
    border: 'none',
    borderRadius: 0,
    flex: '1 1 20%',
    justifyContent: 'center',
    maxWidth: '20%',
    minWidth: 0,
    padding: 0,
    margin: 0,
    width: '20%',
    minHeight: 88,
    '&:hover': {
      border: 'none',
    },
  },
  disabled: {
  },
  icon: {
    color: theme.footerButtons.activeColor,
    display: 'flex',
    fontSize: '2.5rem',
    height: 48,
    justifyContent: 'center',
    lineHeight: 1,
    padding: 0,
    margin: 0,
    width: 48,
    '& svg': {
      height: 40,
      width: 40,
    },
  },
  active: {
    color: theme.footerButtons.selectedColor,
  },
  buttonInnerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 3,
    justifyContent: 'center',
    minWidth: 0,
    width: '100%',
    minHeight: 64,
    padding: 0,
    margin: 0,
  },
  buttonWrapper: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: 0,
    margin: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    backgroundColor: theme.palette.primary.main,
    minHeight: 88,
  },
  buttonWrapperDesktop: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    paddingLeft: 20,
    paddingRight: 20,
    width: '100%',
  },
})

export default styles
